export const ResolutionAPI = {};

const SLICE = 'resolution';


ResolutionAPI.create = (data, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/stream/resolution`,
    method:   'POST',
    data:     data,
    slice:     SLICE,
    action:    'create',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

ResolutionAPI.delete = (ids, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/stream/resolution`,
    method:    'DELETE',
    data:      {ids},
    slice:     SLICE,
    action:    'delete',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

ResolutionAPI.update = (data, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/stream/resolution`,
    method:   'PUT',
    data:     data,
    slice:     SLICE,
    action:    'update',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

ResolutionAPI.list = (data, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/stream/resolutions`,
    method:    'GET',
    data:      data,
    slice:     SLICE,
    action:    'list',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

ResolutionAPI.item = (id, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/stream/resolution`,
    method:    'GET',
    data:      {id},
    slice:     SLICE,
    action:    'item',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

ResolutionAPI.search = (name, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/stream/resolutions`,
    method:    'POST',
    data:      {name},
    slice:     SLICE,
    action:    'search',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};
